import { PerformanceDisclaimerTranslations } from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TranslateFunction = (...args: any[]) => any;

export const getPerformanceDisclaimerClientTranslations = (
  t: TranslateFunction,
): PerformanceDisclaimerTranslations => ({
  disclaimerDynamic: String(
    t('performance_disclaimer_dynamic' as 'general_error_message_title'),
  ),
  disclaimerFixed: String(
    t('performance_disclaimer_fixed' as 'general_error_message_title'),
  ),
  assetSpecificRisks: String(
    t(
      'performance_disclaimer_asset_specific_risks' as 'general_error_message_title',
    ),
  ),
  drawerTitle: String(
    t('performance_disclaimer_drawer_title' as 'general_error_message_title'),
  ),
  assetRisksTitle: String(
    t(
      'performance_disclaimer_asset_risks_title' as 'general_error_message_title',
    ),
  ),
  assetRisksBody: String(
    t(
      'performance_disclaimer_asset_risks_body' as 'general_error_message_title',
    ),
  ),
  assetRisksCta: String(
    t(
      'performance_disclaimer_asset_risks_cta' as 'general_error_message_title',
    ),
  ),
  estimatedEarningsTitle: String(
    t(
      'performance_disclaimer_estimated_earnings_title' as 'general_error_message_title',
    ),
  ),
  estimatedEarningsBody: String(
    t(
      'performance_disclaimer_estimated_earnings_body' as 'general_error_message_title',
    ),
  ),
  gotIt: String(
    t('performance_disclaimer_got_it' as 'general_error_message_title'),
  ),
  periodDay: String(t('stop_order_valid_day' as 'general_error_message_title')),
  periodDays: String(
    t('stop_order_valid_days' as 'general_error_message_title'),
  ),
  periodMonth: String(
    t('stop_order_valid_month' as 'general_error_message_title'),
  ),
  periodMonths: String(
    t('stop_order_valid_months' as 'general_error_message_title'),
  ),
  periodYear: String(
    t('performance_disclaimer_period_year' as 'general_error_message_title'),
  ),
  periodYears: String(
    t('performance_disclaimer_period_years' as 'general_error_message_title'),
  ),
});
